import { render, staticRenderFns } from "./modalViewEventsFields.vue?vue&type=template&id=2858e132&"
import script from "./modalViewEventsFields.vue?vue&type=script&lang=js&"
export * from "./modalViewEventsFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports